<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-Two.html" xml:lang="en-US">
<div class="Basic-Text-Frame-13">
<p class="ch"><a id="Anchor-1"></a>CHAPTER TWO</p>
<p class="body-text-opening"><span class="sc" xml:lang="en-US">T</span><span class="sc-epub" xml:lang="en-US">HE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">FRESH</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">AIR</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">STRUCK</span><span class="sc" xml:lang="en-US">
						G</span><span class="sc-epub" xml:lang="en-US">RACE</span> as soon as she
					stepped out, the cleanness of it startling though she’d been outside just a few
					minutes before. Almost against her will, she took a deep breath, drawing in the
					beauty of it. Even if she’d been surrounded by stucco buildings and ten lanes of
					traffic, there’d be no mistaking that she wasn’t in L.A. anymore. The air was
					too crisp, and when she moved, it hardly even touched her skin. She felt lighter
					as she headed for the faint sounds of music leaking from the saloon next
					door.</p>
<p class="body-text">“The saloon next door,” she murmured. That was something she’d
					never said before. <em class="italic">Bar,</em> yes. <em class="italic">Liquor store,</em> sure. And on one occasion even a strip club. But never
					a saloon.</p>
<p class="body-text">The strip club had actually made a pretty good neighbor. Unlike
					bars and liquor stores, no one wanted to hang around outside a strip club. The
					interesting parts were inside, behind blacked-out windows and plain cement
					walls. And once the place shut down for the night, the girls dropped everything
					and left as if the building made their skin crawl.</p>
<p class="body-text">Grace had always told herself she couldn’t imagine doing that.
					Pretending to like a man for money. Using her body to win favors. But in the
					end, she’d done the same thing, hadn’t she?</p>
<p class="body-text">As she opened the heavy saloon door, she shook that thought
					from her head. What the hell did it matter? She’d done what she’d done, and now
					she was just as miserable as she deserved to be.</p>
<p class="body-text">Old country music filled the saloon, though it wasn’t
					particularly loud. A friendly buzz of conversation overlaid the music. Even at
					3:00 p.m., several of the tables were filled, though not with the usual
					miserable types she associated with afternoon drinking. Two of the groups looked
					like young and scruffy college kids that you’d see in any other town. But at the
					closest table, all five of the men wore cowboy hats. Each man touched the brim
					of his hat as she passed. Grace felt her face flush at the unexpected courtesy
					and hurried past them to the long bar that ran along the side of the
					building.</p>
<p class="body-text">She hadn’t seen her great-aunt in almost twenty years, but the
					blonde woman behind the bar was clearly not Aunt Rayleen. This woman was
					somewhere in her thirties, probably, though her skin was fresh and so pretty she
					could pass for a younger woman.</p>
<p class="body-text">“Hi,” Grace said, catching her attention. “I’m looking for
					Rayleen. Rayleen Kisler?”</p>
<p class="body-text">The woman kept polishing a glass, but offered a wide smile. “Of
					course, sweetie. She’s right over there. Usual table.”</p>
<p class="body-text">Grace followed the gesture to a table at the far corner of the
					bar. An old woman sat there playing solitaire, an unlit cigarette gripped
					tightly between two thin lips. Yeah. That was Aunt Rayleen. She looked as mean
					as ever.</p>
<p class="body-text">“Thank you,” Grace murmured, thinking those weren’t quite the
					right words as she headed across the bar. What she should have said was “Never
					mind” or “Pretend you never saw me.” She should have turned around and grabbed
					her stuff and kept moving. Grace hadn’t even wanted to ask for help from her
					grandmother, much less this sour-faced woman who’d never had a kind word for
					anyone, even when Grace had been a child.</p>
<p class="body-text">And her face had only gotten more sour in the meantime. Though
					her hair was still beautiful. Pure white and flowing past her shoulders in a
					gorgeous wave. Rayleen’s one and only vanity, according to Grandma Rose.</p>
<p class="body-text">Grace finally stood before the table, but the old lady didn’t
					look up. She just scowled down at her cards, flipping over three at a time in a
					slow rhythm. Her pale chambray shirt looked about three sizes too big for
					her.</p>
<p class="body-text">“Aunt Rayleen?” Grace finally ventured.</p>
<p class="body-text">The old lady grunted.</p>
<p class="body-text">“I’m Grace. Grace Barrett.” Still no response. “Your
					niece?”</p>
<p class="body-text">Her silver eyebrows rose and she finally looked up. A sharp
					green gaze took Grace in with one flick of her eyes. “Thought you’d be knocked
					up.”</p>
<p class="body-text">“Pardon me?”</p>
<p class="body-text">Her gaze fell back to the table and she resumed her card
					flipping. “A grown woman who can’t keep a job or support herself and has to
					write to her grandmother to ask for money? I figured you were out of commission.
					But you look perfectly fine to me.”</p>
<p class="body-text">Grace’s skin prickled with violent anger. “If you—”</p>
<p class="body-text">“Aside from the hair.”</p>
<p class="body-text">Grace stiffened and cleared her throat. She didn’t have the
					right to tell this lady off. God, she wanted to, but maybe a free apartment gave
					Rayleen the right to get in a few insults. Which was exactly why Grace hated
					asking for help.</p>
<p class="body-text">“I was living with someone and it didn’t work out. With the
					economy—”</p>
<p class="body-text">“Who told you you could ever depend on a man for anything?”</p>
<p class="body-text">“I… No one told me that.”</p>
<p class="body-text">“You probably learned that from your idiot mama. That woman
					doesn’t have the sense God gave a dog. And dogs ain’t exactly nature’s
					Einsteins, are they?”</p>
<p class="body-text">A strange, hot wash of emotion trickled along Grace’s skin.
					Fury, certainly, but it was mixed up with shame and the awful burn of truth
					spoken bluntly.</p>
<p class="body-text">“Listen,” she pushed out past clenched teeth. “If you don’t
					want me here, say so and I’ll leave right now.”</p>
<p class="body-text">“Yeah? Where are you going to go?”</p>
<p class="body-text">“Anywhere. I’ll find a place. I don’t need your charity.”</p>
<p class="body-text">“Sure you do, or you wouldn’t have taken it in the first place.
					Your grandma is living in that old folk’s home in Florida, and you can’t stay
					there, can you?”</p>
<p class="body-text">No, she couldn’t stay there. Though she’d rather have stayed
					there than have asked Grandma Rose for money. Unfortunately, her grandmother
					hadn’t had any money to spare, but she’d called in a favor from Rayleen. If
					Grace hadn’t been so utterly desperate, she’d never have hopped on that bus.</p>
<p class="body-text">“I can see you’ve got a spine in you. Must’ve skipped a
					generation. You want the place or not?”</p>
<p class="body-text">The burn sank deeper into her skin. She’d always hated that her
					paleness showed her emotions so clearly. Not that she often tried to hide her
					anger, but she wanted it under her control. She wanted to be in charge of who
					saw it and who didn’t. And what she wanted right now was to show this woman
					nothing. To be calm as she turned around and walked out with her chin held high.
					Sure, she had nowhere to go, but a city park bench would be better than politely
					asking this bitch for a key.</p>
<p class="body-text">“Listen, honey,” Rayleen said, finally setting down the cards.
					“It’s not a question of me <em class="italic">wanting</em> you here. I don’t
					know you from Adam. But I’m willing to have you here because I have an empty
					apartment and Rose asked me for a favor. You pay the utilities and you can stay.
					But just through ski season. August is one thing, but come December? I’ve got my
					eye on a handsome snowboarding instructor I had to turn away last year.”</p>
<p class="body-text">That broke through Grace’s fury. A handsome snowboarding
					instructor? For what? The apartment or an affair? Jeez, this woman really was
					crazy. But that didn’t mean Grace wanted to accept her grudging handout.</p>
<p class="body-text">She was opening her mouth to tell Aunt Rayleen to do something
					foul to herself, but the old woman grinned, showing off perfectly white teeth
					past the cigarette dangling from her lips.</p>
<p class="body-text">“You’re pissed, ain’t ya? I like that. Pride’s a beautiful
					thing, but you’ve got to ask yourself where your pride has gotten you up to this
					point. Because as far as I can tell, it’s gotten you homeless and bitter. You
					enjoying the taste of that?”</p>
<p class="body-text">Good Lord, the things she wanted to do to this woman would
					constitute elder abuse, but Aunt Rayleen was just so rude. And mean. And <em class="italic">right.</em></p>
<p class="body-text">That was the worst part. The hardest to swallow. She was right.
					Grace had too much pride. Hell, sometimes it was all she had. But pride didn’t
					fill your stomach or keep the cold out. So she swallowed hard. And swallowed
					again, tasting every bitter molecule of it. And then she nodded.</p>
<p class="body-text">“Thank you for the place to stay,” she managed to growl. “I’ll
					be out in a month.”</p>
<p class="body-text">Rayleen laughed. “Oh, big words. We’ll see. For now, just don’t
					knock out any walls or leave a window open when it rains. No smoking. No pets.
					The key’s in the cash register. Jenny over there will give it to you.”</p>
<p class="body-text">“Thank you,” Grace managed one more time. The words tasted just
					as bitter the second time around, and she wished she had the money to spare for
					a beer as she approached the bar. Wished her life was as simple as sitting down
					and washing the day away with a cold one. Better yet, a double of whiskey. God,
					yes.</p>
<p class="body-text">“Hi, again,” the bartender offered.</p>
<p class="body-text">Grace made herself smile back. This woman gave off a good vibe.
					She probably made a lot of money as a bartender. It was a skill. Grace knew that
					because she’d tried her hand at it and failed. People just didn’t like her. But
					this woman… She was comforting. “Are you Jenny?”</p>
<p class="body-text">“I am.”</p>
<p class="body-text">“Rayleen told me to ask you for a key to apartment A?”</p>
<p class="body-text">“You?” Jenny asked. Her eyes nearly disappeared when she
					laughed. “You’ll be quite a change.”</p>
<p class="body-text">“Do I need to check the place for hidden cameras?” she asked,
					only half joking.</p>
<p class="body-text">“You’re probably safe. She just likes to collect them, I think,
					not spy on them. Nothing too creepy.” Jenny hit a button on the register and the
					drawer popped open.</p>
<p class="body-text">“It seems plenty creepy,” Grace muttered.</p>
<p class="body-text">“She’s pretty harmless. They like to come over here and tease
					her, but she calls them puppies and tells them to leave her the hell alone.”
					Jenny held out the key and dropped it into Grace’s hand. “Welcome to
					Jackson.”</p>
<p class="body-text">“Thank you.” That was it. No paperwork. No contracts or legal
					indemnification. “Do you know anyone who’s hiring?”</p>
<p class="body-text">“Summer’s a little tight and we’re getting to the end of it.
					What do you do?”</p>
<p class="body-text">Grace shrugged. “Waitressing. Busing tables. I’ve done some
					cleaning.”</p>
<p class="body-text">“Anything else? You look like a woman who might have other
					skills.”</p>
<p class="body-text">For a moment, Grace’s blood froze. What did that mean? Other
					skills? Stripping? Turning tricks? She knew she looked a little harder than
					people in Wyoming, but she hadn’t expected to be confronted with the same shit
					she’d lived with on the streets of L.A.</p>
<p class="body-text">“Have you worked in clothing stores?” Jenny continued, as
					friendly as before.</p>
<p class="body-text">Grace blinked. Is that what she’d meant? Something so
					innocuous? “Uh, sure. I worked in a vintage place when I was young. And I do
					makeup.”</p>
<p class="body-text">“Makeup?”</p>
<p class="body-text">“I work as a makeup artist. In L.A.”</p>
<p class="body-text">“Oh.” Jenny’s eyes widened. “That’s really cool.”</p>
<p class="body-text">“But not very useful in Wyoming.”</p>
<p class="body-text">“Maybe, but it’s got to pay better than waitressing in a
					tourist town.”</p>
<p class="body-text">“That depends,” Grace said.</p>
<p class="body-text">“On what?”</p>
<p class="body-text">“On whether you can avoid pissing off the fifty different
					people on a movie set who can get you fired.”</p>
<p class="body-text">Jenny laughed. “Well, maybe you should go see Eve Hill. She’s a
					photographer and she’s pretty nice. She might have work for you.”</p>
<p class="body-text">Grace made an effort not to look doubtful, but she’d almost
					rather be a waitress than do bridal makeup for wedding shoots. “What kind of
					photography?” she asked warily.</p>
<p class="body-text">“I’m not sure. She does some landscape stuff on her own. Sells
					it in town here, but she does other things, too. Photo shoots for
					magazines.”</p>
<p class="body-text">“Here?”</p>
<p class="body-text">The doubt must’ve been showing clearly now, because Jenny shook
					her head and offered a look of friendly patience. “We might be in the middle of
					nowhere, but there’s money here. Lots of money and lots of those people you know
					from L.A. They like to come and ski and play dress-up, and they like to have a
					reason to be here. Film shoots and fashion campaigns provide that.”</p>
<p class="body-text">“Right. Yeah. Okay, I’ll look her up.”</p>
<p class="body-text">“Do that. And if that doesn’t work out, I’ll let you know the
					good places to be a server here, and the places you want to avoid.”</p>
<p class="body-text">“Thank you so much.”</p>
<p class="body-text">Jenny winked with the natural friendliness of a really great
					bartender, then moved on to serve the two men who’d just pulled up to the
					bar.</p>
<p class="body-text">“Eve Hill,” Grace murmured. It probably wouldn’t work out. The
					woman likely had no need for a makeup artist. But if there was any chance Grace
					could avoid working tables again, she’d suck up her pride. Maybe she’d even
					volunteer for bride duty. After all, there was a common denominator among all
					these people Grace wasn’t very good with. Customers, bosses, lovers, brides. The
					common denominator was Grace. She was the problem.</p>
<p class="body-text">She clutched the key tight in her hand and walked out of the
					bar without meeting the eyes of any of the patrons.</p>
<p class="body-text">People didn’t like her.</p>
<p class="body-text">Well, that wasn’t exactly true. She had friends. She even had
					really good friends, like Merry Kade, who’d been her best friend for ten years.
					So some people liked her. Just not the ones who controlled her pay. Although up
					until a few months ago, that hadn’t been a problem. She was good enough with
					makeup that she didn’t have to kiss butt to keep her job. She’d done just fine.
					She hadn’t had to ask anyone for help.</p>
<p class="body-text">But that was before.</p>
<p class="body-text">It didn’t matter. She’d asked for help this time, hadn’t she?
					And she hated it. She hated it like she’d never hated anything else. Somehow it
					was worse than the time she’d spent on the streets as a kid, accepting food from
					soup kitchens and charities. It was worse than crashing on a friend’s couch for
					a few days, because she could say she’d done the same for them at some point.
					This was out-and-out asking for help, and it stung.</p>
<p class="body-text">But it was better than going to jail.</p>
<p class="body-text">She stood in front of the pretty blue house and opened up her
					fist. Her skin showed the exact shape of the key. Every ridge and angle pressed
					red into her palm.</p>
<p class="body-text">“Just a few weeks,” she whispered. “Just a month.” And if she
					didn’t like the feeling of begging for scraps, then she’d better get used to the
					idea of keeping her mouth shut around people who controlled her paycheck.
					Because it was one or the other, and she’d be damned if she’d ever ask for
					charity again.</p>
<p class="Basic-Paragraph-10"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_Two.vue?650444ce